export const certificates = [
  {
    title: "C & C++ Mastery",
    category: "Programming",
    img: "/assets/c.jpg",
  },
  {
    title: "Power BI For Beginners",
    category: "Tools",
    img: "/assets/Power Bi.png",
  },
  {
    title: "PostgreSQL Database",
    category: "Database",
    img: "/assets/Postgre Sql.png",
  },
  {
    title: "Docker Essentials",
    category: "Tools",
    img: "/assets/Docker.png",
  },
];
